module.exports = __webpack_public_path__ + "static/img/1051_big.9e1b05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1051_big.png
// module id = GBqH
// module chunks = 1